module.exports = __webpack_public_path__ + "static/img/TikTok.b40c6bba.png";